import React, { useEffect, useState, useMemo, useRef } from 'react';


import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { constituenciesFetchData } from '../../../redux/actions/constituencies';
import { citiesListFetchData } from '../../../redux/actions/citiesListAction';

import './Electionpage.css';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip as RechartsTooltip, Legend } from 'recharts';
import { EleResultsFetchData } from '../../../redux/actions/EleResultsAction';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const normalize = (str) => (str || "").toLowerCase().replace(/&/g, "and").replace(/\s+/g, "").replace(/[^a-z0-9]/g, "");

const ElectionDetailpage = ({ selectedState, stateIdProp, cityIdProp }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const cityParam = searchParams.get('city');
  const stateParam = searchParams.get('state');
  const cityIdParam = cityIdProp;
  const stateIdParam = stateIdProp;

  const dispatch = useDispatch();
  const yearFromPath = location.pathname.includes('2021') ? '2021' : '2026';
  const election_id = location.state?.election_id || (yearFromPath === '2021' ? 6 : 5);

  const { 21: assetbaseUrl, 57: liveYtUrl } = useSelector(
    (state) => state?.SettingReducer?.data,
  );

  const [selectedRowId, setSelectedRowId] = useState(null);
  const [localCityId, setLocalCityId] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const detailRef = useRef(null);
  const resultGridRef = useRef(null);
  const carouselRef = useRef(null);

  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 1400 }, items: 4 },
    desktop: { breakpoint: { max: 1400, min: 1024 }, items: 3 },
    tablet: { breakpoint: { max: 1024, min: 768 }, items: 2 },
    mobile: { breakpoint: { max: 768, min: 0 }, items: 1 }
  };


  // 1. Explicit Detection Logic
  const detectionMode = useMemo(() => {
    if (selectedRowId) return 'constituency';
    if (cityIdProp) return 'city';
    if (stateIdProp) return 'state';
    return 'summary';
  }, [stateIdProp, cityIdProp, localCityId, selectedRowId]);

  useEffect(() => {
    // Reset selections when parent state or city changes
    setSelectedRowId(null);
    setLocalCityId(null);
    setIsExpanded(false);
  }, [stateIdProp, cityIdProp]);

  useEffect(() => {
    // Fetch data if at least state is selected
    if (stateIdParam) {
      dispatch(citiesListFetchData(stateIdParam, election_id));
    }
  }, [stateIdParam, dispatch, election_id]);


  const stateListRootStore = useSelector((state) => state?.stateListReducer?.data) || {};
  const stateListData = stateListRootStore?.data || (Array.isArray(stateListRootStore) ? stateListRootStore : []);
  const stateListParties = stateListRootStore?.parties || [];

  const stateSummaryReducerStore = useSelector((state) => state?.stateSummaryReducer?.data) || [];
  const stateSummaryData = Array.isArray(stateSummaryReducerStore?.data) ? stateSummaryReducerStore.data : (Array.isArray(stateSummaryReducerStore) ? stateSummaryReducerStore : []);

  const citiesListReducerData = useSelector((state) => state?.citiesListReducer);
  const citiesLoading = citiesListReducerData?.loading;
  const citiesListData = citiesListReducerData?.data?.parties || [];
  const OnlycitiesList = (citiesListReducerData?.data?.data || []).filter(city => String(city.state_id) === String(stateIdParam));

  const constituenciesReducer = useSelector((state) => state?.constituenciesReducer);
  const constituenciesLoading = constituenciesReducer?.loading;
  const constituenciesData = constituenciesReducer?.data?.data || [];
  const constituency_candidates = constituenciesReducer?.data?.constituency_candidates || [];
  const drillDownParties = constituenciesReducer?.data?.parties || []
  const EleResultsReducer = useSelector((state) => state?.EleResultsReducer?.data);

  // 2. Data Binding based on Detection Logic
  const summaryParties = useMemo(() => {
    if (selectedState && stateSummaryData && stateSummaryData.length > 0) {
      const matchingState = stateSummaryData.find(s => normalize(s.state_name) === normalize(selectedState));
      if (matchingState && matchingState.parties) return matchingState.parties;
    }
    return stateSummaryData[0]?.parties || [];
  }, [selectedState, stateSummaryData]);

  const parties = useMemo(() => {
    console.log("Current Detection Mode:", detectionMode);

    // Clear data during active loading for the specific mode to show loading UI
    if (detectionMode === 'city' && constituenciesLoading) return [];
    if (detectionMode === 'state' && citiesLoading) return [];

    // 1. Constituency or City Level (City-specific data)
    if (detectionMode === 'constituency' || detectionMode === 'city') {
      if (drillDownParties && drillDownParties.length > 0) return drillDownParties;
      if (citiesListData && citiesListData.length > 0) return citiesListData;
    }

    // 2. State Level (State-specific data)
    if (detectionMode === 'state') {
      // debugger
      if (citiesListData && citiesListData.length > 0) return citiesListData;
      // if (stateListData && stateListData.length > 0) return stateListData;

      // Fallback to name-based filtering from summary data if direct state list is empty
      if (selectedState) {
        const matchingState = stateSummaryData.find(s => normalize(s.state_name) === normalize(selectedState));
        if (matchingState && matchingState.parties) return matchingState.parties;
      }
    }

    return summaryParties || [];
  }, [detectionMode, drillDownParties, citiesListData, stateListData, summaryParties, constituenciesLoading, citiesLoading, selectedState, stateSummaryData]);

  console.log(stateListData, "stateListDatastateListDatastateListData");
  console.log(summaryParties, "summaryPartiessummaryPartiessummaryParties");
  console.log(parties, "partiespartiespartiesparties");
  console.log(drillDownParties, "drillDownPartiesdrillDownPartiesdrillDownParties");


  // useMemo for chartData to ensure it's calculated efficiently and correctly
  const chartData = useMemo(() => {
    if (!parties || !Array.isArray(parties)) return [];
    return parties
      .filter(party => (parseFloat(party.avg_vote_percentage) || 0) > 0)
      .map(party => ({
        name: party.name,
        value: parseFloat(party.avg_vote_percentage),
        color: party.color_code || '#cccccc'
      }));
  }, [parties]);



  const flattenedCandidates = parties?.flatMap(party =>
    (party.breakdown || []).map(candidate => ({
      ...candidate,
      partyName: party.name,
      partyShortName: party.short_name,
      partyColorCode: party.color_code
    }))
  );




  const handleClickrow = (id) => {
    setSelectedRowId(id);
    dispatch(EleResultsFetchData(id, election_id));

    // Smooth scroll to the result details section
    setTimeout(() => {
      if (detailRef.current) {
        detailRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };


  const handleCityclick = (city) => {
    setLocalCityId(city.id);
    setSelectedRowId(null); // Clear any previously selected constituency results
    dispatch(constituenciesFetchData(city?.state_id, city.id, election_id))

    // Scroll to results section 
    setTimeout(() => {
      if (resultGridRef.current) {
        resultGridRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }

  return (
    <div className="ed-page-wrapper">

      <main className="ed-main ed-space-y-8">

        {/* Header Section & Summary Cards */}
        <section className="ed-space-y-6">


          {/* Quick Summary Cards */}
          <div className="ed-section-header-row">
            <h3 className="ed-section-title heading-font"></h3>
            {parties && parties.length >= 4 && (
              <div className="ed-carousel-actions">
                <button onClick={() => carouselRef?.current?.previous()} className="ed-nav-btn prev">
                  <i className="fas fa-chevron-left"></i>
                </button>
                <button onClick={() => carouselRef?.current?.next()} className="ed-nav-btn next">
                  <i className="fas fa-chevron-right"></i>
                </button>
              </div>
            )}
          </div>

          <div className="ed-party-summary-wrapper">
            {parties && parties.length > 0 ? (
              parties.length >= 4 ? (
                <Carousel
                  ref={carouselRef}
                  responsive={responsive}
                  infinite={true}
                  autoPlay={false}
                  renderArrowsWhenDisabled={true}
                  partialVisible={false}
                  swipeable={true}
                  keyBoardControl={true}
                  arrows={false}
                  containerClass="ed-party-carousel-container"
                  itemClass="ed-carousel-item-p"
                >
                  {parties.map((party) => (
                    <div key={party.id}
                      className="ed-carousel-card-wrap"
                      style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '1rem',
                        overflow: 'hidden',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                        border: '1px solid #f3f4f6',
                        display: 'flex',
                        flexDirection: 'column',
                        transition: 'all 0.2s ease',
                        cursor: 'default',
                        margin: '10px',
                        height: 'calc(100% - 20px)'
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)' }}
                    >
                      <div style={{ height: '6px', width: '100%', backgroundColor: party.color_code }}></div>

                      <div style={{ padding: '0.875rem', display: 'flex', flexDirection: 'column', height: '100%' }}>

                        {/* Header: Logo and Name */}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <div style={{
                              width: '5rem',
                              height: '5rem',
                              borderRadius: '1rem',
                              backgroundColor: `${party.color_code}15`,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              border: `1px solid ${party.color_code}30`,
                              flexShrink: 0,
                              boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                              overflow: 'hidden'
                            }}>
                              {party.logo ? (
                                <img
                                  src={`${assetbaseUrl?.value}${party.logo}`}
                                  alt={party.short_name}
                                  style={{ objectFit: 'contain' }}
                                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                                />
                              ) : (
                                <svg viewBox="0 0 24 24" fill={party.color_code} style={{ width: '60%', height: '60%', opacity: 0.3 }}>
                                  <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 16.66 14.67 14 12 14Z" />
                                </svg>
                              )}
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                              <h2 style={{ fontSize: '1rem', fontWeight: 800, color: party.color_code, lineHeight: 1.25 }} >
                                {party.name}
                              </h2>
                              <h1 style={{ fontSize: '9px', fontWeight: 'bold', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em', lineHeight: 1, marginBottom: '0.25rem' }}>
                                ({party.short_name})
                              </h1>
                            </div>
                          </div>

                          <div style={{ textAlign: 'right' }}>
                            <div style={{ fontSize: '1.5rem', fontWeight: 900, color: '#111827', lineHeight: 1 }}>
                              {party.won + party.leading}
                            </div>
                            <div style={{ fontSize: '9px', fontWeight: 'bold', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '-0.05em', marginTop: '4px' }}>
                              / {party.total_seats} Seats
                            </div>
                          </div>
                        </div>

                        {/* Vote Share Progress */}
                        <div style={{ marginBottom: '0.75rem' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '0.25rem' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.025em' }}>
                              Vote Share
                            </span>
                            <span style={{ fontSize: '1.25rem', fontWeight: 900, color: party.color_code, lineHeight: 1 }}>
                              {party.avg_vote_percentage}%
                            </span>
                          </div>
                          <div style={{ width: '100%', height: '0.5rem', backgroundColor: '#f3f4f6', borderRadius: '9999px', overflow: 'hidden' }}>
                            <div style={{
                              height: '100%',
                              backgroundColor: party.color_code,
                              borderRadius: '9999px',
                              width: `${party.avg_vote_percentage}%`,
                              boxShadow: `0 0 8px ${party.color_code}80`
                            }}></div>
                          </div>
                        </div>

                        {/* Won / Leading Stats */}
                        <div style={{ marginTop: 'auto', display: 'flex', gap: '0.5rem' }}>
                          <div style={{
                            flex: 1,
                            backgroundColor: `${party.color_code}0F`,
                            borderRadius: '0.75rem',
                            padding: '0.5rem',
                            border: `1px solid ${party.color_code}25`,
                            textAlign: 'center',
                            opacity: party.won === 0 ? 0.5 : 1
                          }}>
                            <div style={{ fontSize: '9px', fontWeight: 'bold', color: party.color_code, textTransform: 'uppercase' }}>seates</div>
                            <div style={{ fontSize: '1.125rem', fontWeight: 800, color: party.color_code, lineHeight: 1, marginTop: '4px' }}>{party?.won}</div>
                          </div>
                          <div style={{
                            flex: 1,
                            backgroundColor: '#f9fafb',
                            borderRadius: '0.75rem',
                            padding: '0.5rem',
                            border: '1px solid #f3f4f6',
                            textAlign: 'center',
                            opacity: party.leading === 0 ? 0.5 : 1
                          }}>
                            <div style={{ fontSize: '9px', fontWeight: 'bold', color: '#9ca3af', textTransform: 'uppercase' }}>Total votes</div>
                            <div style={{ fontSize: '1.125rem', fontWeight: 800, color: '#374151', lineHeight: 1, marginTop: '4px' }}>{party?.total_votes}</div>
                          </div>
                        </div>

                      </div>
                    </div>
                  ))}
                </Carousel>
              ) : (
                <div className="ed-party-summary-grid">
                  {parties.map((party) => (
                    <div key={party.id}
                      style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '1rem',
                        overflow: 'hidden',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                        border: '1px solid #f3f4f6',
                        display: 'flex',
                        flexDirection: 'column',
                        transition: 'all 0.2s ease',
                        cursor: 'default'
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'; }}
                    >
                      <div style={{ height: '6px', width: '100%', backgroundColor: party.color_code }}></div>

                      <div style={{ padding: '0.875rem', display: 'flex', flexDirection: 'column', height: '100%' }}>

                        {/* Header: Logo and Name */}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <div style={{
                              width: '5rem',
                              height: '5rem',
                              borderRadius: '1rem',
                              backgroundColor: `${party.color_code}15`,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              border: `1px solid ${party.color_code}30`,
                              flexShrink: 0,
                              boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                              overflow: 'hidden'
                            }}>
                              {party.logo ? (
                                <img
                                  src={`${assetbaseUrl?.value}${party.logo}`}
                                  alt={party.short_name}
                                  style={{ objectFit: 'contain' }}
                                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                                />
                              ) : (
                                <svg viewBox="0 0 24 24" fill={party.color_code} style={{ width: '60%', height: '60%', opacity: 0.3 }}>
                                  <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 16.66 14.67 14 12 14Z" />
                                </svg>
                              )}
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                              <h2 style={{ fontSize: '9px', fontWeight: 'bold', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em', lineHeight: 1, marginBottom: '0.25rem' }}>
                                {party.name}
                              </h2>
                              <h1 style={{ fontSize: '1.25rem', fontWeight: 800, color: party.color_code, lineHeight: 1.25 }}>
                                ({party.short_name})
                              </h1>
                            </div>
                          </div>

                          <div style={{ textAlign: 'right' }}>
                            <div style={{ fontSize: '1.5rem', fontWeight: 900, color: '#111827', lineHeight: 1 }}>
                              {party.won + party.leading}
                            </div>
                            <div style={{ fontSize: '9px', fontWeight: 'bold', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '-0.05em', marginTop: '4px' }}>
                              / {party.total_seats} Seats
                            </div>
                          </div>
                        </div>

                        {/* Vote Share Progress */}
                        <div style={{ marginBottom: '0.75rem' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '0.25rem' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.025em' }}>
                              Vote Share
                            </span>
                            <span style={{ fontSize: '1.25rem', fontWeight: 900, color: party.color_code, lineHeight: 1 }}>
                              {party.avg_vote_percentage}%
                            </span>
                          </div>
                          <div style={{ width: '100%', height: '0.5rem', backgroundColor: '#f3f4f6', borderRadius: '9999px', overflow: 'hidden' }}>
                            <div style={{
                              height: '100%',
                              backgroundColor: party.color_code,
                              borderRadius: '9999px',
                              width: `${party.avg_vote_percentage}%`,
                              boxShadow: `0 0 8px ${party.color_code}80`
                            }}></div>
                          </div>
                        </div>

                        {/* Won / Leading Stats */}
                        <div style={{ marginTop: 'auto', display: 'flex', gap: '0.5rem' }}>
                          <div style={{
                            flex: 1,
                            backgroundColor: `${party.color_code}0F`,
                            borderRadius: '0.75rem',
                            padding: '0.5rem',
                            border: `1px solid ${party.color_code}25`,
                            textAlign: 'center',
                            opacity: party.won === 0 ? 0.5 : 1
                          }}>
                            <div style={{ fontSize: '9px', fontWeight: 'bold', color: party.color_code, textTransform: 'uppercase' }}>seates</div>
                            <div style={{ fontSize: '1.125rem', fontWeight: 800, color: party.color_code, lineHeight: 1, marginTop: '4px' }}>{party?.won}</div>
                          </div>
                          <div style={{
                            flex: 1,
                            backgroundColor: '#f9fafb',
                            borderRadius: '0.75rem',
                            padding: '0.5rem',
                            border: '1px solid #f3f4f6',
                            textAlign: 'center',
                            opacity: party.leading === 0 ? 0.5 : 1
                          }}>
                            <div style={{ fontSize: '9px', fontWeight: 'bold', color: '#9ca3af', textTransform: 'uppercase' }}>Total votes</div>
                            <div style={{ fontSize: '1.125rem', fontWeight: 800, color: '#374151', lineHeight: 1, marginTop: '4px' }}>{party?.total_votes}</div>
                          </div>
                        </div>

                      </div>
                    </div>
                  ))}
                </div>
              )
            ) : (
              <div style={{ backgroundColor: '#ffffff', borderRadius: '1rem', padding: '1.5rem', border: '1px solid #f3f4f6' }}>
                <p style={{ color: '#9ca3af', fontWeight: 'bold', fontSize: '11px', textTransform: 'uppercase' }}>Loading Summary</p>
                <h3 style={{ fontSize: '1.5rem', fontWeight: 800 }}>...</h3>
              </div>
            )}
          </div>
        </section>

        {selectedState && <div><div className="ed-space-y-1">
          <h1 className="ed-title heading-font text-center"><span style={{ color: 'var(--sandesh-red)' }}>Cities</span></h1>
        </div>   </div>}

        {console.log(OnlycitiesList, "OnlycitiesListOnlycitiesListOnlycitiesList")
        }

        {selectedState && Array.isArray(OnlycitiesList) && OnlycitiesList.length > 0 && (
          <div className="ed-city-selection-container">
            <div className="ed-city-cards-grid">
              {OnlycitiesList.slice(0, isExpanded ? OnlycitiesList.length : 12).map((city) => (
                <div
                  key={city.id}
                  className={`ed-city-card ${cityIdParam === city.id.toString() ? 'active' : ''}`}
                  onClick={() => handleCityclick(city)}
                >
                  <div className="ed-city-card-icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>

                  <div className="ed-city-card-info">
                    <div className="ed-city-card-name">{city.name}</div>
                  </div>
                </div>
              ))}
            </div>

            {OnlycitiesList.length > 12 && (
              <div className="ed-expand-action">
                <button
                  className="ed-read-more-btn"
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {isExpanded ? (
                    <>Show Less <i className="fas fa-chevron-up"></i></>
                  ) : (
                    <>Read More ({OnlycitiesList.length - 12} more) <i className="fas fa-chevron-down"></i></>
                  )}
                </button>
              </div>
            )}
          </div>
        )}


        {/* Main Data Grid */}
        {selectedState && <div className="ed-grid-main" ref={resultGridRef}>

          {/* Left Column: Results & Candidates */}
          <div className="ed-grid-left ed-space-y-8">
            {/* Constituency List */}
            <div className="ed-sidebar-card" style={{ padding: 0, overflow: 'visible' }}>
              <div className="ed-table-header">
                <h3 className="ed-table-title heading-font"> <span style={{ color: 'var(--sandesh-red)' }}>  {selectedState}</span> Constituency List</h3>
                <div className="ed-table-actions">
                  <button className="ed-action-btn"><i className="fa-solid fa-sort"></i></button>
                  <button className="ed-action-btn"><i className="fa-solid fa-filter"></i></button>
                </div>
              </div>
              <div className="ed-table-scroll" style={{
                overflowX: 'auto',
                WebkitOverflowScrolling: 'touch',
                display: 'block',
                width: '100%',
                position: 'relative',
                touchAction: 'pan-x'
              }}>
                <table className="ed-table-core" style={{ minWidth: '800px', tableLayout: 'auto' }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'left', padding: '1rem' }}>Party</th>
                      <th style={{ textAlign: 'left', padding: '1rem' }}>Location</th>
                      <th style={{ textAlign: 'left', padding: '1rem' }}>Candidate Name</th>
                      <th style={{ textAlign: 'left', padding: '1rem' }}>Result</th>
                    </tr>
                  </thead>
                  <tbody>
                    {constituency_candidates && constituency_candidates.length > 0 ? (
                      constituency_candidates.map((constituency, conIdx) => {
                        const uniqueCandidates = [];
                        const seenCand = new Set();

                        constituency.candidates?.forEach(cand => {
                          const key = `${cand.candidate_name}-${cand.party_id}`;
                          if (!seenCand.has(key)) {
                            seenCand.add(key);
                            uniqueCandidates.push(cand);
                          }
                        });

                        return uniqueCandidates.map((candidate, candIdx) => {
                          const status = candidate.result_status?.toLowerCase();
                          let statusBg = '#f1f5f9';
                          let statusColor = '#64748b';
                          if (status === 'won') {
                            statusBg = '#dcfce7'; statusColor = '#16a34a';
                          } else if (status === 'leading' || status === 'lead' || status === 'pending') {
                            statusBg = '#e0f2fe'; statusColor = '#0284c7';
                          } else if (status === 'lost' || status === 'trailing') {
                            statusBg = '#fee2e2'; statusColor = '#dc2626';
                          }

                          return (
                            <tr key={`${conIdx}-${candIdx}`} style={{ borderBottom: candIdx === uniqueCandidates.length - 1 ? '2px solid #e2e8f0' : '1px solid #f1f5f9' }}>
                              {/* Column 1: Party */}
                              <td style={{ padding: '1rem 0.5rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '0.75rem', paddingLeft: '0.5rem' }}>
                                  <div style={{
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '6px',
                                    backgroundColor: '#ffffff',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '1px solid #e2e8f0',
                                    padding: '2px',
                                    flexShrink: 0
                                  }}>
                                    {candidate.party_logo ? (
                                      <img
                                        src={`${assetbaseUrl?.value}${candidate.party_logo}`}
                                        alt={candidate.party_name}
                                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                      />
                                    ) : <i className="fas fa-flag" style={{ color: '#cbd5e1', fontSize: '0.7rem' }}></i>}
                                  </div>
                                  <span style={{ fontSize: '0.75rem', fontWeight: 700, color: '#475569', textAlign: 'left', lineHeight: 1.1 }}>
                                    {candidate.party_name}
                                  </span>
                                </div>
                              </td>

                              {/* Column 2: Location (Merged Cell) */}
                              {candIdx === 0 && (
                                <td
                                  rowSpan={uniqueCandidates.length}
                                  style={{
                                    padding: '1rem',
                                    backgroundColor: '#f8fafc',
                                    borderRight: '1px solid #e2e8f0',
                                    verticalAlign: 'middle'
                                  }}
                                >
                                  <span style={{ fontSize: '1rem', fontWeight: 900, color: '#0f172a', fontFamily: "'Outfit', sans-serif", letterSpacing: '0.01em' }}>
                                    {constituency.name}
                                  </span>
                                </td>
                              )}

                              {/* Column 3: Candidate Name */}
                              <td style={{ padding: '1rem 0.5rem' }}>
                                <div style={{ fontWeight: 600, color: '#334155', fontSize: '0.9rem', paddingLeft: '0.5rem' }}>{candidate.candidate_name}</div>
                              </td>

                              {/* Column 4: Result */}
                              <td style={{ padding: '1rem 0.5rem' }}>
                                <div style={{ paddingLeft: '0.5rem' }}>
                                  <span className="ed-status-btn" style={{
                                    background: statusBg,
                                    color: statusColor,
                                    animation: (status === 'leading' || status === 'pending') ? 'ed-pulse 2s infinite' : 'none',
                                    padding: '0.35rem 0.85rem',
                                    fontSize: '0.7rem',
                                    fontWeight: 900,
                                    borderRadius: '6px',
                                    textTransform: 'uppercase',
                                    border: `1px solid ${statusColor}15`
                                  }}>
                                    {candidate.result_status || 'Pending'}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      })
                    ) : (
                      <tr>
                        <td colSpan="4" style={{ textAlign: 'center', padding: '4rem', color: '#94a3b8' }}>
                          No data available.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Detailed Results Section */}
            {(selectedRowId && EleResultsReducer && EleResultsReducer.length > 0) && (
              <div ref={detailRef} className="ed-sidebar-card ed-fade-in" style={{ padding: '1.25rem', marginBottom: '2rem', animation: 'fadeIn 0.3s ease' }}>
                <div className="ed-live-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem', borderBottom: '1px solid #e2e8f0', paddingBottom: '1rem', flexWrap: 'wrap', gap: '0.75rem' }}>
                  <h3 className="ed-table-title heading-font" style={{ margin: 0 }}>
                    Live Counting: <span style={{ color: 'var(--sandesh-red)' }}>{EleResultsReducer[0].constituency_name}</span>
                  </h3>
                  <div className="ed-round-badge" style={{ fontSize: '0.8rem', color: '#64748b' }}>
                    Round: <span style={{ fontWeight: 'bold', color: '#0f172a' }}>{EleResultsReducer[0].round_number || 1}</span>
                  </div>
                </div>

                <div className="ed-live-counting-grid">
                  {EleResultsReducer.map((cand) => (
                    <div key={cand.id} className="ed-live-card">
                      {/* Top Color Bar */}
                      <div style={{ height: '4px', width: '100%', backgroundColor: cand.color_code || '#cbd5e1' }}></div>

                      <div className="ed-live-card-body">
                        <div className="ed-live-card-avatar-wrap">
                          {cand.candidate_photo ? (
                            <img
                              src={`${assetbaseUrl?.value}${cand.candidate_photo}`}
                              alt={cand.candidate_name}
                              style={{ width: '4.5rem', height: '4.5rem', borderRadius: '50%', objectFit: 'cover', border: `3px solid ${cand.color_code || '#e2e8f0'}` }}
                              onError={(e) => { e.currentTarget.style.display = 'none'; }}
                            />
                          ) : (
                            <div style={{ width: '4.5rem', height: '4.5rem', borderRadius: '50%', backgroundColor: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', border: `3px solid ${cand.color_code || '#e2e8f0'}` }}>
                              <svg viewBox="0 0 24 24" fill="#cbd5e1" style={{ width: '70%', height: '70%' }}>
                                <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 16.66 14.67 14 12 14Z" />
                              </svg>
                            </div>
                          )}
                          <div style={{
                            position: 'absolute',
                            bottom: '-4px',
                            right: '-4px',
                            width: '1.75rem',
                            height: '1.75rem',
                            backgroundColor: '#fff',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                            border: `1px solid ${cand.color_code}40`
                          }}>
                            {cand.party_logo ? (
                              <img src={`${assetbaseUrl?.value}${cand.party_logo}`} alt={cand.party_short_name} style={{ width: '70%', height: '70%', objectFit: 'contain' }} />
                            ) : (
                              <span style={{ fontSize: '0.5rem', fontWeight: 'bold', color: cand.color_code }}>{cand.party_short_name}</span>
                            )}
                          </div>
                        </div>

                        {/* Details Column */}
                        <div className="ed-live-card-details">
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <div>
                              <h4 style={{ fontSize: '1.1rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.2, margin: '0 0 0.25rem 0' }}>{cand.candidate_name}</h4>
                              <p style={{ fontSize: '0.8rem', color: '#64748b', margin: 0, fontWeight: 600 }}>{cand.party_name}</p>
                            </div>
                            <span style={{
                              padding: '0.25rem 0.5rem',
                              borderRadius: '9999px',
                              fontSize: '0.65rem',
                              fontWeight: 800,
                              textTransform: 'uppercase',
                              letterSpacing: '0.05em',
                              backgroundColor: cand.status === 'won' ? '#dcfce7' : cand.status === 'leading' || cand.status === 'lead' ? '#e0f2fe' : cand.status === 'lost' ? '#fee2e2' : '#ffedd5',
                              color: cand.status === 'won' ? '#16a34a' : cand.status === 'leading' || cand.status === 'lead' ? '#0284c7' : cand.status === 'lost' ? '#dc2626' : '#ea580c',
                              border: `1px solid ${cand.status === 'won' ? '#22c55e' : cand.status === 'leading' || cand.status === 'lead' ? '#0ea5e9' : cand.status === 'lost' ? '#ef4444' : '#f97316'}40`
                            }}>
                              {cand.status}
                            </span>
                          </div>

                          <div className="ed-live-card-stats-row">
                            <div>
                              <div style={{ fontSize: '0.65rem', textTransform: 'uppercase', color: '#94a3b8', fontWeight: 700, margin: '0 0 0.125rem 0' }}>Votes</div>
                              <div style={{ fontSize: '1.05rem', fontWeight: 900, color: '#334155', fontFamily: 'monospace' }}>{cand.votes_received?.toLocaleString() || 0}</div>
                            </div>
                            <div style={{ width: '1px', backgroundColor: '#e2e8f0', margin: '0.25rem 0' }}></div>
                            <div>
                              <div style={{ fontSize: '0.65rem', textTransform: 'uppercase', color: '#94a3b8', fontWeight: 700, margin: '0 0 0.125rem 0' }}>Share</div>
                              <div style={{ fontSize: '1.05rem', fontWeight: 900, color: cand.color_code || '#334155', fontFamily: 'monospace' }}>{cand.vote_percentage}%</div>
                            </div>
                            {(cand.margin > 0) && (
                              <>
                                <div style={{ width: '1px', backgroundColor: '#e2e8f0', margin: '0.25rem 0' }}></div>
                                <div>
                                  <div style={{ fontSize: '0.65rem', textTransform: 'uppercase', color: '#94a3b8', fontWeight: 700, margin: '0 0 0.125rem 0' }}>Margin</div>
                                  <div style={{ fontSize: '1.05rem', fontWeight: 900, color: '#16a34a', fontFamily: 'monospace' }}>+{cand.margin?.toLocaleString()}</div>
                                </div>
                              </>
                            )}
                          </div>

                        </div>
                      </div>

                      {/* Sub-bar showing progress percentage like a real election meter */}
                      <div style={{ width: '100%', height: '3px', backgroundColor: '#f1f5f9' }}>
                        <div style={{ width: `${Math.min(cand.vote_percentage, 100)}%`, height: '100%', backgroundColor: cand.color_code || '#cbd5e1' }}></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}


          </div>

          {/* Right Column: Maps, Charts & Timeline */}
          <div className="ed-grid-right ed-space-y-8">
            <div className="ed-sidebar-card">
              <div className="ed-card-title-row">
                <h3 className="ed-card-title heading-font">Vote Share Analysis</h3>
                <span className="ed-cand-detail">By Party</span>
              </div>
              <div className="ed-chart-container">
                {chartData && chartData.length > 0 ? (
                  <>
                    <div style={{ height: '220px', width: '100%' }}>
                      <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                          <Pie
                            data={chartData}
                            innerRadius={55}
                            outerRadius={90}
                            paddingAngle={3}
                            dataKey="value"
                            stroke="none"
                          >
                            {chartData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                          </Pie>
                          <RechartsTooltip
                            formatter={(value) => `${value.toFixed(2)}%`}
                            contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)' }}
                          />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                    <div className="ed-chart-legend-custom">
                      {chartData.map((entry, index) => (
                        <div key={index} className="ed-legend-item">
                          <span className="ed-legend-dot" style={{ backgroundColor: entry.color }}></span>
                          <span className="ed-legend-text">{entry.name}</span>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <p className="ed-cand-detail" style={{ textAlign: 'center', marginTop: '4rem' }}>No data available for chart</p>
                )}

              </div>
            </div>

            <div className="ed-sidebar-card">
              <h3 className="ed-card-title heading-font" style={{ marginBottom: '1.5rem' }}>Party Standings</h3>
              <div className="ed-party-standings">
                {parties && parties.length > 0 ? (
                  parties.map((party) => {
                    const partySeats = party.won + party.leading;
                    const totalSeats = parties.reduce((acc, p) => acc + p.won + p.leading, 0) || 1; // Avoid div by 0
                    const seatPercentage = Math.round((partySeats / totalSeats) * 100);
                    {
                      console.log(partySeats, "partySeatspartySeats")
                    }
                    return (
                      <div key={party.id}>
                        <div className="ed-party-row-top">
                          <span>{party.name} {party.alliance ? `(${party.alliance})` : ''}</span>
                          <span style={{ color: party.color_code || '#64748b' }}>
                            {partySeats} Seats ({seatPercentage}%)
                          </span>
                        </div>
                        <div className="ed-progress-full">
                          <div
                            className="ed-progress-full-inner"
                            style={{ width: `${seatPercentage}%`, background: party.color_code || '#64748b' }}
                          ></div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p className="ed-cand-detail">Loading standings...</p>
                )}
              </div>
            </div>
          </div>
        </div>}
      </main>



    </div>
  );
};

export default ElectionDetailpage;

